import { CommonInput, CommonModal, MapInput } from "components";
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import dummyMap from "../../../src/assets/img/dummyMap.webp";
import {
    GoogleMap,
    useJsApiLoader,
    InfoWindow,
    Marker,
    MarkerClusterer,
    InfoBox,
    Circle,
    DirectionsService,
    DirectionsRenderer,
    TrafficLayer,
} from "@react-google-maps/api";
import { UserContext } from "context";
import { useGoogleMaps } from "components/GoogleMapsProvider/GoogleMapsProvider";
import toast from "react-hot-toast";
import StorageService from "utils/StorageServices";
import { createLocation } from "_services/accountsServices/locationService";
import { createCityLocation } from "_services/accountsServices/cityLocationService";
import { IoLocationSharp } from "react-icons/io5";
import { errorSchema, utils } from "helper";
import { GOOGLE_MAP_API_KEY } from '../../lib/app-config'

const stateCodeMap = {
    "ANDHRA PRADESH": "37",
    "ARUNACHAL PRADESH": "12",
    "ASSAM": "18",
    "BIHAR": "10",
    "CHHATTISGARH": "22",
    "DELHI": "07",
    "GOA": "30",
    "GUJARAT": "24",
    "HARYANA": "06",
    "HIMACHAL PRADESH": "02",
    "JAMMU AND KASHMIR": "01",
    "JHARKHAND": "20",
    "KARNATAKA": "29",
    "KERALA": "32",
    "MADHYA PRADESH": "23",
    "MAHARASHTRA": "27",
    "MANIPUR": "14",
    "MEGHALAYA": "17",
    "MIZORAM": "15",
    "NAGALAND": "13",
    "ODISHA": "21",
    "PUNJAB": "03",
    "RAJASTHAN": "08",
    "SIKKIM": "11",
    "TAMIL NADU": "33",
    "TELANGANA": "36",
    "TRIPURA": "16",
    "UTTAR PRADESH": "09",
    "UTTARAKHAND": "05",
    "WEST BENGAL": "19",
    "ANDAMAN AND NICOBAR ISLANDS": "35",
    "CHANDIGARH": "04",
    "DADRA AND NAGAR HAVELI AND DAMAN AND DIU": "26",
    "LAKSHADWEEP": "31",
    "PUDUCHERRY": "34",
    "LADAKH": "38",
};

const AddLocationModal = (props) => {
    const { 
        isOpen, 
        mapAddressData = "", 
        callBackDataMap = () => { }, 
        isEwayBillMap = false, 
        editData, 
        showPinCode = false, 
        setLocationGstCode = () => { } 
    } = props;

    const object = {
        company_id: StorageService.getCompanyId(),
        name: "",
        countryCode: "",
        stateCode: "",
        stateName: "",
        latitude: "",
        longitude: "",
        postalCode: "",
    }

    const mapStyle = [
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#00FF00" }]
        },
    ];

    const isLoaded = useGoogleMaps();
    const mapMavigation = navigator.geolocation;

    const lat = mapAddressData && typeof mapAddressData.geometry?.location?.lat === "function"
        ? mapAddressData.geometry.location.lat()
        : 28.7041;

    const lng = mapAddressData && typeof mapAddressData.geometry?.location?.lng === "function"
        ? mapAddressData.geometry.location.lng()
        : 77.1025;

    const [map, setMap] = useState(null);
    const [mapMaker, setMapMAker] = useState(null);
    const [activeMarker, setActiveMarker] = useState(null);
    const [city, setCity] = useState("");
    const [center, setCenter] = useState({ lat: Number(lat), lng: Number(lng) });
    const [circleRadius, setCircleRadius] = useState(1000);
    const [circleRef, setCircleRef] = useState(null);
    const [location, setLocation] = useState({ lat: Number(lat), lng: Number(lng) });
    const [selectFormat, setSelectFormat] = useState();
    const [formError, setFormError] = useState("");
    const [form, setForm] = useState(object);
    const [submitLoading, setSubmitLoading] = useState(false);
    
    // Ref to prevent infinite loop in getLocationPincode
    const lastFetchedCoords = useRef({ lat: null, lng: null });
    
    // FIXED: Geocoder should depend on isLoaded
    const geocoder = useMemo(
        () => (isLoaded ? new window.google.maps.Geocoder() : null),
        [isLoaded]
    );

    // Helper function to extract city/locality from address components
    const extractCityFromComponents = (addressComponents) => {
        if (!addressComponents) return "";
        
        const cityTypes = [
            "locality",
            "postal_town",
            "sublocality",
            "sublocality_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3"
        ];

        for (const cityType of cityTypes) {
            const component = addressComponents.find(comp => 
                comp.types && comp.types.includes(cityType)
            );
            if (component && component.long_name) {
                return component.long_name;
            }
        }
        return "";
    };

    // Helper function to normalize state name
    const normalizeStateName = (name) => {
        if (!name) return "";
        return name.toUpperCase().trim().replace(/\s+/g, ' ');
    };

    const loadHandler = (map) => {
        setMap(map);
    };

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    useEffect(() => {
        if (mapAddressData && geocoder) {
            getFormatAddres(lat, lng);
        }
    }, [mapAddressData, geocoder]);

    const getFormatAddres = (latValue, langValue) => {
        if (!geocoder) {
            console.warn("Geocoder not initialized");
            return;
        }

        geocoder.geocode(
            { location: { lat: latValue, lng: langValue } },
            (results, status) => {
                if (status === "OK" && results && results[0]) {
                    const country = results[0].address_components.find((component) =>
                        component.types.includes("country")
                    )?.long_name;

                    if (country !== "India") {
                        toast.error("Please select a location within India.");
                        return;
                    }

                    setSelectFormat(results[0]);
                    setSelectLoctionDetails(results[0]);
console.log(results)
                    const addressComponents = results[0].address_components;
                    let formattedAddress = {
                        city: "",
                        stateName: "",
                        country: "",
                        postalCode: "",
                    };

                    // Extract city using helper function
                    formattedAddress.city = extractCityFromComponents(addressComponents);

                    for (const component of addressComponents) {
                        if (component.types.includes("administrative_area_level_1")) {
                            formattedAddress.stateName = component.long_name;
                        }
                        if (component.types.includes("country")) {
                            formattedAddress.country = component.long_name;
                        }
                        if (component.types.includes("postal_code")) {
                            formattedAddress.postalCode = component.long_name;
                        }
                    }

                    const cityPart = formattedAddress.city ? `${formattedAddress.city}, ` : "";
                    const postalPart = formattedAddress.postalCode ? ` ${formattedAddress.postalCode}` : "";
                    const finalFormattedAddress = `${cityPart}${formattedAddress.stateName}${postalPart}, ${formattedAddress.country}`;
                    setCity(finalFormattedAddress);
                } else {
                    console.error("Geocode was not successful for the following reason:", status);
                }
            }
        );
    };

    // FIXED: This function now properly calls setSelectLoctionDetails
    const handleCityChange = (value) => {
        if (!value) return;
        
        console.log("Selected location:", value);
        
        setSelectFormat(value);
        setCity(value?.formatted_address || "");
        
        const getLat = typeof value?.geometry?.location?.lat === "function"
            ? value.geometry.location.lat()
            : null;
        const getLng = typeof value?.geometry?.location?.lng === "function"
            ? value.geometry.location.lng()
            : null;

        if (getLat !== null && getLng !== null) {
            const newLocation = { lat: getLat, lng: getLng };
            setLocation(newLocation);
            setCenter(newLocation);
        }
        
        // CRITICAL FIX: Call setSelectLoctionDetails to populate form fields
        setSelectLoctionDetails(value);
    };

    const setSelectLoctionDetails = (place) => {
        if (!place?.address_components) {
            console.warn("No address components found in place");
            return;
        }

        const addressComponents = place.address_components;
        console.log("place",place)

        let formattedAddress = {
            name: "",
            stateCode: "",
            stateName: "",
            countryCode: "",
            countryName: "",
            latitude: "",
            longitude: "",
            postalCode: ""
        };

        // Extract city using helper function
        // formattedAddress.name = extractCityFromComponents(addressComponents);
        formattedAddress.name = place?.formatted_address;


        for (const component of addressComponents) {
            if (component.types.includes("administrative_area_level_1")) {
                formattedAddress.stateName = component.long_name;
                formattedAddress.stateCode = component.short_name;
            }
            if (component.types.includes("country")) {
                formattedAddress.countryName = component.long_name;
                formattedAddress.countryCode = component.short_name;
            }
            if (component.types.includes("postal_code")) {
                formattedAddress.postalCode = component.long_name;
            }
        }

        // Get GST state code
        const key = normalizeStateName(formattedAddress.stateName);
        let gstStateCode = stateCodeMap[key] || "";
        
        if (gstStateCode) {
            setLocationGstCode(gstStateCode);
        } else {
            console.warn(`No GST code found for state: ${formattedAddress.stateName}`);
        }

        const lat = typeof place?.geometry?.location?.lat === "function"
            ? place.geometry.location.lat()
            : null;
        const lng = typeof place?.geometry?.location?.lng === "function"
            ? place.geometry.location.lng()
            : null;

        setForm({
            ...form,
            name: place.name,
            countryName: formattedAddress.countryName,
            countryCode: formattedAddress.countryCode,
            stateName: formattedAddress.stateName,
            stateCode: formattedAddress.stateCode,
            latitude: lat,
            longitude: lng,
            postalCode: formattedAddress.postalCode,
        });
        
        setCity(place?.formatted_address);

        if (lat !== null && lng !== null) {
            const newLocation = { lat, lng };
            setLocation(newLocation);
            setCenter(newLocation);
        }
        
        setCircleRadius(1000);
        setFormError("");
    };

    const containerStyle = {
        width: "100%",
        height: "400px",
    };

    const options = useMemo(
        () => ({
            disableDefaultUI: true,
            clickableIcons: true,
            zoomControl: true,
            restriction: {
                latLngBounds: {
                    north: 37.0838,
                    south: 6.4627,
                    east: 97.3956,
                    west: 68.1097,
                },
                strictBounds: true,
            },
            styles: mapStyle,
        }),
        []
    );

    const onMapClick = (event) => {
        if (!event?.latLng) return;
        
        const newLocation = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        };
        setLocation(newLocation);
        setCenter(newLocation);
        getFormatAddres(newLocation.lat, newLocation.lng);
    };

    const handleSubmitCity = async () => {
        setSubmitLoading(true);
        
        if (!form?.name || form.name.trim() === "") {
            setFormError((prev) => ({ ...prev, name: "Please enter location name" }));
            toast(
                "Please search location and select a location.",
                {
                    icon: <IoLocationSharp style={{ color: "red", fontSize: 30 }} />,
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }
            );
            setSubmitLoading(false);
            return;
        }
        
        try {
            const res = await createCityLocation(form);
            if (res?.responseCode === 200) {
                if (res?.responseMessage) {
                    toast.success(res?.responseMessage);
                }
                callBackDataMap(res?.data?.city);
                setSubmitLoading(false);
                props.closeModal();
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                } else {
                    toast.error("Failed to create location. Please try again.");
                }
                setSubmitLoading(false);
            }
        } catch (error) {
            console.error("Error creating city location:", error);
            toast.error("An error occurred. Please try again.");
            setSubmitLoading(false);
        }
    };

    const handleSubmitEwayBillData = async () => {
        setSubmitLoading(true);
        
        if (!form?.name || form.name.trim() === "") {
            setFormError((prev) => ({ ...prev, name: "Please enter location name" }));
            toast(
                "Please search location and select a location.",
                {
                    icon: <IoLocationSharp style={{ color: "red", fontSize: 30 }} />,
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }
            );
            setSubmitLoading(false);
            return;
        }
        
        try {
            if (showPinCode) {
                const validationResult = await utils?.checkFormError(form, errorSchema.googleMapSchema);
                if (utils?.isObjectKeyEmpty(validationResult)) {
                    callBackDataMap(form);
                    setSubmitLoading(false);
                    props.closeModal();
                } else {
                    toast.error("Please fill all required fields correctly.");
                    setSubmitLoading(false);
                }
            } else {
                callBackDataMap(form);
                setSubmitLoading(false);
                props.closeModal();
            }
        } catch (error) {
            console.error("Error submitting eway bill data:", error);
            toast.error("An error occurred. Please try again.");
            setSubmitLoading(false);
        }
    };

    const propsMapLocation = {
        ...props,
        onSubmit: isEwayBillMap ? handleSubmitEwayBillData : handleSubmitCity,
        isLoadding: submitLoading,
        disabled: submitLoading,
    };

    const onCircleDragEnd = (event) => {
        if (!event?.latLng) return;
        
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        const newLocation = { lat: newLat, lng: newLng };
        setCenter(newLocation);
        setLocation(newLocation);
        getFormatAddres(newLat, newLng);
    };

    const onCircleRadiusChanged = () => {
        if (circleRef) {
            const newRadius = circleRef.getRadius();
            setCircleRadius(Math.floor(newRadius));
        }
    };

    const handleRadiusChange = (e) => {
        const value = Number(e.target.value);
        if (!isNaN(value) && value >= 0) {
            setCircleRadius(value);
        }
    };

    // FIXED: Edit mode properly sets location and center
    useEffect(() => {
        if (isOpen?.action === 'edit' && editData) {
            setForm(editData);
            setCity(editData?.name || "");
            
            const key = normalizeStateName(editData?.stateName);
            let gstStateCode = stateCodeMap[key] || "";
            
            if (gstStateCode) {
                setLocationGstCode(gstStateCode);
            }

            // Set location and center for edit mode
            if (editData.latitude && editData.longitude) {
                const editLocation = {
                    lat: Number(editData.latitude),
                    lng: Number(editData.longitude)
                };
                setLocation(editLocation);
                setCenter(editLocation);
            }
        } else if (isOpen && !editData) {
            // Reset form when opening for new entry
            setForm(object);
            setCity("");
            const defaultLoc = { lat: 28.7041, lng: 77.1025 };
            setLocation(defaultLoc);
            setCenter(defaultLoc);
            setFormError("");
            lastFetchedCoords.current = { lat: null, lng: null };
        }
    }, [isOpen?.action, isOpen, editData]);

    // FIXED: Prevent infinite loop by checking if coordinates actually changed
    const getLocationPincode = async (lat, lng) => {
        if (!lat || !lng || !GOOGLE_MAP_API_KEY) return;
        
        // Prevent fetching if coordinates haven't changed
        if (lastFetchedCoords.current.lat === lat && lastFetchedCoords.current.lng === lng) {
            return;
        }
        
        lastFetchedCoords.current = { lat, lng };
        
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_API_KEY}`
            );
            const data = await response.json();

            if (data.status !== "OK") {
                console.warn("Geocoding API error:", data.status);
                return;
            }

            let city = "";
            let pincode = "";
            let state = "";
            let stateCode = "";
            let gstStateCode = "";

            if (data.results && data.results.length > 0) {
                const components = data.results[0].address_components;

                // Extract city using helper function
                city = extractCityFromComponents(components);

                for (const comp of components) {
                    if (comp.types.includes("postal_code")) {
                        pincode = comp.long_name;
                    } else if (comp.types.includes("administrative_area_level_1")) {
                        const possibleState = normalizeStateName(comp.long_name);
                        if (!state && stateCodeMap[possibleState]) {
                            state = comp.long_name;
                            stateCode = comp?.short_name?.toUpperCase();
                            gstStateCode = stateCodeMap[possibleState];
                        }
                    }
                }
            }

            setForm((s) => ({
                ...s,
                name: city || s.name,
                postalCode: pincode || s.postalCode,
                stateName: state || s.stateName,
                stateCode: stateCode || s.stateCode,
            }));
            
            if (gstStateCode) {
                setLocationGstCode(gstStateCode);
            }
        } catch (error) {
            console.error("Error fetching location pincode:", error);
        }
    };

    useEffect(() => {
        if (form.latitude && form.longitude) {
            getLocationPincode(form.latitude, form.longitude);
        }
    }, [form.latitude, form.longitude]);

    return (
        <>
            <CommonModal {...propsMapLocation}>
                <div className="addMap_body">
                    <div className="_inrPrt_flx2" style={{ marginBottom: "20px" }}>
                        <div className="singleDiv">
                            <MapInput
                                label="Search on Map"
                                value={city}
                                handleInputChange={handleCityChange}
                                setSelectLoctionDetails={setSelectLoctionDetails}
                            />
                        </div>

                        <div className="singleDiv">
                            <div className="flxInr">
                                <div className="halfDiv">
                                    <CommonInput
                                        type="text"
                                        label="Location Name"
                                        placeholder="location_name"
                                        value={form?.name || ""}
                                        disabled
                                    />
                                </div>
                                <div className="halfDiv">
                                    <CommonInput
                                        type="text"
                                        label="State"
                                        placeholder="stateName"
                                        value={form?.stateName || ""}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="singleDiv">
                            <div className="flxInr">
                                <div className="halfDiv">
                                    <CommonInput
                                        type="text"
                                        label="Latitude"
                                        placeholder="latitude"
                                        value={form?.latitude || ""}
                                        disabled
                                    />
                                </div>
                                <div className="halfDiv">
                                    <CommonInput
                                        type="text"
                                        label="Longitude"
                                        placeholder="longitude"
                                        value={form?.longitude || ""}
                                        disabled
                                    />
                                </div>
                                {showPinCode && (
                                    <div className="halfDiv">
                                        <CommonInput
                                            type="text"
                                            label="Pin Code"
                                            placeholder="Pin Code"
                                            value={form?.postalCode || ""}
                                            disabled
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {isLoaded ? (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={10}
                            options={options}
                            onLoad={loadHandler}
                            onUnmount={onUnmount}
                            onClick={() => setActiveMarker(null)}
                        >
                            <Marker 
                                position={location}
                                draggable={true}
                                onDragEnd={(e) => {
                                    if (!e?.latLng) return;
                                    const newLat = e.latLng.lat();
                                    const newLng = e.latLng.lng();
                                    const newLocation = { lat: newLat, lng: newLng };
                                    setLocation(newLocation);
                                    setCenter(newLocation);
                                    getFormatAddres(newLat, newLng);
                                }} 
                            />
                            <Circle
                                center={center}
                                radius={circleRadius}
                                options={{
                                    strokeColor: "#FF0000",
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: "#FF0000",
                                    fillOpacity: 0.35,
                                    draggable: true,
                                    editable: true,
                                }}
                                onDragEnd={onCircleDragEnd}
                                onRadiusChanged={onCircleRadiusChanged}
                                onLoad={(circle) => setCircleRef(circle)}
                            />
                            <TrafficLayer autoUpdate />


                        </GoogleMap>
                    ) : (
                        <></>
                    )}

                </div>
            </CommonModal>
        </>
    );
};

export default AddLocationModal;
